import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { take, takeUntil } from 'rxjs/operators';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ManifestoService } from 'src/app/services/manifesto/manifesto.service';
import { RealtorioRessalvaService } from 'src/app/services/realtorio-ressalva.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { ManifestoDetalhesComponent } from './manifesto-detalhes/manifesto-detalhes.component';
import { ModalManifestoSolicitacaoProrrogacaoSlaComponent } from './modal-manifesto-solicitacao-prorrogacao-sla/modal-manifesto-solicitacao-prorrogacao-sla.component';
import { detectar_mobile } from 'src/app/@shared/helpers/vesta-helpers';
import {
  ModalManifestoEmbarquePainelDetalheComponent,
  PaginacaoComponent,
} from 'src/app/@shared/components';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ModalConfirmacaoComponent } from 'src/app/@shared/components/modal-confirmacao/modal-confirmacao.component';
import { ReplaySubject, Subject } from 'rxjs';

@Component({
  selector: 'app-manifestos-painel',
  templateUrl: './manifestos-painel.component.html',
  styleUrls: ['./manifestos-painel.component.scss'],
})
export class ManifestosPainelComponent implements OnInit {
  habilitarProrrogacao = false;
  habilitarBaixa = false;
  habilitarProrrogacaoPainelMT = false;
  habilitarBaixaPainelMT = false;
  habilitarProrrogacaoPainelManifesto = false;
  habilitarBaixaPainelManifesto = false;
  featureId;
  private onDestroy = new Subject<void>();
  public regionais;
  public filteredRegionais: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public regionalMultiFilter: FormControl = new FormControl();

  public filteredAgentes: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public agenteMultiFilter: FormControl = new FormControl();
  agentes: Array<any>;

  public isLoading = false;
  public isLoadingCards = false;
  public initialTime = true;
  public paging = { index: 0, size: 10, length: 0 };
  public error = {} as any;
  public isMobile: boolean;
  // public agentes: Array<any>;
  // public regionais: Array<any>;
  public isDisabledRegional: boolean = false;
  public isDisabledAgente: boolean = false;
  public regionaisSelected: string[];
  public agentesSelected: string[];
  public perfilAcessoTipo: any;
  public panelCollection: MatTableDataSource<any> =
    new MatTableDataSource<any>();
  public colorScheme: any = {
    domain: ['#fbff14', '#d7df23', '#0cc760', '#fca212', '#20853c', '#cf0a14'],
  };
  public cardsFilter = {
    totalPendentes: false,
    totalBaixados: false,
    naoExpiradosSemRessalva: false,
    naoExpiradosComRessalva: false,
    expiradosSemRessalva: false,
    expiradosComRessalva: false,
  };
  public view: [number, number] = [1200, 180];
  public cardColor: string = '#fefefe';
  public cards: any;
  public modeloFiltroPainelManifesto: any;
  public panelForm: FormGroup = new FormGroup({
    regionalIds: new FormControl(),
    agenteIds: new FormControl(),
    tipoSituacaoVisualizacaoId: new FormControl({
      value: '0',
      disabled: false,
    }),
    necessarioME: new FormControl({ value: '-1', disabled: false }),
    tipoManifesto: new FormControl({ value: 'Todos', disabled: false }),
    numeroCompletoManifesto: new FormControl(),
    dataInicial: new FormControl(),
    dataFinal: new FormControl(),
    codigoBarras: new FormControl(),
    ordenacao: new FormControl({ value: 'Id', disabled: false }),
  });

  get regionalIds() {
    return this.panelForm.get('regionalIds').value;
  }
  get agenteIds() {
    return this.panelForm.get('agenteIds').value;
  }
  get tipoSituacaoVisualizacaoId() {
    return this.panelForm.get('tipoSituacaoVisualizacaoId').value;
  }
  get necessarioME() {
    return this.panelForm.get('necessarioME').value;
  }
  get tipoManifesto() {
    return this.panelForm.get('tipoManifesto').value;
  }
  get numeroCompletoManifesto() {
    return this.panelForm.get('numeroCompletoManifesto').value;
  }
  get dataInicial() {
    return this.panelForm.get('dataInicial').value;
  }
  get dataFinal() {
    return this.panelForm.get('dataFinal').value;
  }
  get codigoBarras() {
    return this.panelForm.get('codigoBarras').value;
  }
  get ordenacao() {
    return this.panelForm.get('ordenacao').value;
  }

  public displayedColumns: string[] = [
    'acoes',
    'manifestoEmbarqueId',
    'tipoManifesto',
    'numeroManifesto',
    'volume',
    'valor',
    'tipoSituacaoManifesto',
    'dtBaixa',
    'usuarioBaixa',
    'dtVencRessalva',
    'qtdRessalvas',
    'stProrrogSLA',
  ];
  @ViewChild(PaginacaoComponent, { static: false })
  paginator: PaginacaoComponent;
  constructor(
    private manifestoService: ManifestoService,
    private relatorioRessalvaService: RealtorioRessalvaService,
    public router: Router,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    public authService: AuthService
  ) {
    if (!this.featureId) {
      this.featureId = 'paineis.manifesto-devolucao-transporte.painel-manifestos-devolucao-transporte';
    }
  }

  ngOnInit() {
    // Painéis > MDT > Painéis de MDTs
    this.authService
      .checkFeature(`${this.featureId}.habilitar-prorrogacao`)
      .subscribe((temPermissao) => {
        if (temPermissao === true) this.habilitarProrrogacao = true;
      });
    this.authService
      .checkFeature(`${this.featureId}.habilitar-baixa`)
      .subscribe((temPermissao) => {
        if (temPermissao === true) this.habilitarBaixa = true;
      });

     //Painéis > MT > Painel de MTs
    this.authService
      .checkFeature(`paineis.manifesto-transferencia.painel-manifestos-transferencia.habilitar-prorrogacao`)
      .subscribe((temPermissao) => {
        if (temPermissao === true) this.habilitarProrrogacaoPainelMT = true;
      });
    this.authService
      .checkFeature(`paineis.manifesto-transferencia.painel-manifestos-transferencia.habilitar-baixa`)
      .subscribe((temPermissao) => {
        if (temPermissao === true) this.habilitarBaixaPainelMT = true;
      });

    // Transferências > MT > Painel de MTs
    this.authService
      .checkFeature(`transferencias.manifesto-transferencia.painel-manifestos.habilitar-prorrogacao`)
      .subscribe((temPermissao) => {
        if (temPermissao === true) this.habilitarProrrogacaoPainelManifesto = true;
      });
    this.authService
      .checkFeature(`transferencias.manifesto-transferencia.painel-manifestos.habilitar-baixa`)
      .subscribe((temPermissao) => {
        if (temPermissao === true) this.habilitarBaixaPainelManifesto = true;
      });

    this.initDateTimeFilter();
    this.initRegionais();
    this.initParameters();
    this.isMobile = detectar_mobile();
  }

  public search(shouldResetPagination: boolean = true) {
    if (this.initialTime === true && this.tipoSituacaoVisualizacaoId != 2)
      this.cardsFilter.totalPendentes = true;

    if (!(this.regionalIds?.length > 0)) {
      this.openSnackBar('Por favor informe ao menos uma regional!', 'OK', 9000);
      return;
    }

    if (!(this.agenteIds?.length > 0)) {
      this.openSnackBar('Por favor informe ao menos um agente!', 'OK', 9000);
      return;
    }

    if (
      this.dataInicial &&
      this.dataFinal &&
      this.dataFinal < this.dataInicial
    ) {
      this.openSnackBar(
        'Por favor informe um período de busca válido!',
        'OK',
        9000
      );
      return;
    }

    if (
      (!this.dataInicial && !this.numeroCompletoManifesto) ||
      (!this.dataFinal && !this.numeroCompletoManifesto) ||
      (!this.numeroCompletoManifesto && !this.dataFinal && !this.dataInicial) ||
      (Date.parse(this.dataFinal) - Date.parse(this.dataInicial)) /
      1000 /
      60 /
      60 >
      168
    ) {
      this.openSnackBar(
        'Por favor informe um manifesto ou estreite o período de busca para no máximo 7 dias!',
        'OK',
        9000
      );
      return;
    }

    if (
      this.codigoBarras &&
      this.codigoBarras != null &&
      ((Number(this.codigoBarras) &&
        Number.parseInt(this.codigoBarras) > 2147483647) ||
        (Number(this.codigoBarras) &&
          !Number.isSafeInteger(Number.parseInt(this.codigoBarras))))
    ) {
      this.openSnackBar(
        'Inteiro maior do que o permitido!',
        'OK',
        5000,
        'warning-snackbar'
      );
      return;
    }

    this.openSnackBarOnlyMessage(
      'Pesquisando dados. Por favor, aguarde...',
      3000
    );

    let tipoSituacaoManifestoId;
    this.resetOrNotPagination(shouldResetPagination);

    if (this.cardsFilter.totalPendentes === true) tipoSituacaoManifestoId = 1;
    else if (this.cardsFilter.totalBaixados === true)
      tipoSituacaoManifestoId = 2;
    else if (this.cardsFilter.naoExpiradosSemRessalva === true)
      tipoSituacaoManifestoId = 3;
    else if (this.cardsFilter.naoExpiradosComRessalva === true)
      tipoSituacaoManifestoId = 4;
    else if (this.cardsFilter.expiradosSemRessalva === true)
      tipoSituacaoManifestoId = 5;
    else if (this.cardsFilter.expiradosComRessalva === true)
      tipoSituacaoManifestoId = 6;

    this.setLoading(true);
    this.changeCursorCards();
    this.panelCollection.data = null;
    const input = {
      dataInicial: this.dataInicial
        ? this.dataInicial.toISOString().split('T')[0]
        : null,
      dataFinal: this.dataFinal
        ? this.dataFinal.toISOString().split('T')[0]
        : null,
      tipoSituacaoVisualizacaoId: this.tipoSituacaoVisualizacaoId,
      tipoSituacaoManifestoId: tipoSituacaoManifestoId,
      tipoManifesto: this.tipoManifesto.toString(),
      regionalIds: this.regionalIds,
      agenteIds: this.agenteIds,
      necessarioME: this.necessarioME,
      numeroCompletoManifesto: this.numeroCompletoManifesto,
      paginaAtual: this.paging.index,
      itensPorPagina: this.paging.size,
      codigoBarras: this.codigoBarras,
      ordenacao: this.ordenacao,
    } as any;

    this.manifestoService
      .getManifestoPainelCards(input)
      .pipe(take(1))
      .subscribe(
        (response) => {
          this.cards = response.body;
          this.initialTime = false;
          Object.assign(this, { cards: this.cards });
          this.isLoadingCards = false;
          this.updateCardsColors();
          this.setDefaultSelected();
          this.changeCursorCards();
        },
        () => {
          this.setLoading(false);
          this.isLoadingCards = false;
          this.changeCursorCards();
          this.openSnackBar(
            'Erro ao carregar listagem!',
            'OK',
            5000,
            'danger-snackbar'
          );
          this.initialTime = false;
        }
      );

    this.manifestoService
      .getAllManifestos(input)
      .pipe(take(1))
      .subscribe(
        (response: HttpResponse<any[]>) => {
          //console.log(response.body);
          this.panelCollection.data = response.body;
          if (response.body.length > 0) {
            this.paging.length = response.body[0].totalCount;
          }
          this.setLoading(false);
          this.changeCursorCards();
        },
        () => {
          this.setLoading(false);
          this.changeCursorCards();
          this.openSnackBar(
            'Erro ao carregar listagem!',
            'OK',
            5000,
            'danger-snackbar'
          );
        }
      );
  }

  public openModalManifestoPedidos(
    meDetalheItem: any,
    isDevolucao: boolean
  ): void {
    const modalReference = this.dialog.open(ManifestoDetalhesComponent, {
      width: '1300px',
      maxWidth: '90vw',
      data: { item: { meDetalheItem: meDetalheItem, isDevolucao } },
    });

    modalReference.afterClosed().subscribe(() => {
      // this.search();
    });
  }

  public searchAgente() {
    this.agentes = [];
    this.agentesSelected = [];
    const obj = {
      regionaisIds: this.regionalIds,
      paginaAtual: 0,
      itensPorPagina: 1000000,
    };
    this.relatorioRessalvaService.getAllAgentsIds(obj).subscribe(
      (response: any) => {
        this.agentes = response.body
          .filter((x) => x.nome && x.nome)
          .sort((a, b) => (a.codIATA < b.codIATA ? -1 : 1));
        this.filteredAgentes.next(this.agentes.slice());
        this.agenteMultiFilter.valueChanges
          .pipe(takeUntil(this.onDestroy))
          .subscribe(() => {
            this.filtroGeral(
              this.agentes,
              this.agenteMultiFilter,
              this.filteredAgentes,
              'nome'
            );
          });
        if (this.agentes != null && this.agentes.length === 1) {
          this.panelForm
            .get('agenteIds')
            .setValue(this.agentes.map((x) => x.id));
          this.panelForm.get('agenteIds').disable();
        }
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.isLoading = false;
        this.openSnackBar(
          'Erro ao carregar agentes, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message,
          'OK',
          10000,
          'danger-snackbar'
        );
      }
    );
  }

  public toggleCards(event) {
    if (!this.isLoading) {
      this.isLoadingCards = true;
      this.updateSelected(event);
      this.search();
    }
  }

  public onChangeEvent() {
    this.error = {} as any;
  }

  public updateSelected(event) {
    this.resetCardsFilterSelecteds(event);
    if (this.cards) {
      for (let index = 0; index < this.cards.length; index++) {
        let object = this.cards[index];
        const element = document.querySelectorAll('[ngx-charts-card]')[index];
        this.changeCursorCards(element);

        var checked = this.cardsFilter[object.extra];
        if (checked) {
          (<any>element.childNodes[0].childNodes[0]).style.removeProperty(
            'stroke-dasharray'
          );
          (<any>element.childNodes[0].childNodes[0]).style.setProperty(
            'stroke',
            '#495057'
          );
          (<any>element.childNodes[0].childNodes[0]).style.setProperty(
            'stroke-width',
            '5px'
          );
        } else {
          (<any>element.childNodes[0].childNodes[0]).style.removeProperty(
            'stroke'
          );
          (<any>element.childNodes[0].childNodes[0]).style.removeProperty(
            'stroke-width'
          );
        }
      }
    }
  }

  public updateCardsFlags() {
    if (this.tipoSituacaoVisualizacaoId == 0) {
      this.cardsFilter.totalPendentes = true;
      this.cardsFilter.totalBaixados = false;
    } else if (this.tipoSituacaoVisualizacaoId == 1) {
      this.cardsFilter.totalPendentes = true;
      this.cardsFilter.totalBaixados = false;
    } else if (this.tipoSituacaoVisualizacaoId == 2) {
      this.cardsFilter.totalBaixados = true;
      this.cardsFilter.totalPendentes = false;
    }

    // this.search();
  }

  public updateCardsColors() {
    if (this.tipoSituacaoVisualizacaoId == 0) {
      this.view = [1800, 180];
      this.colorScheme = {
        domain: [
          '#fbff14',
          '#d7df23',
          '#0cc760',
          '#fca212',
          '#20853c',
          '#cf0a14',
        ],
      };
    } else if (this.tipoSituacaoVisualizacaoId == 1) {
      this.view = [320, 180];
      this.colorScheme = {
        domain: ['#fbff14'],
      };
    } else if (this.tipoSituacaoVisualizacaoId == 2) {
      this.view = [1800, 180];
      this.colorScheme = {
        domain: ['#d7df23', '#0cc760', '#fca212', '#20853c', '#cf0a14'],
      };
    }
    // this.search();
  }

  public async initRegionais() {
    const obj = {
      paginaAtual: 0,
      itensPorPagina: 1000000,
    };
    return this.relatorioRessalvaService
      .getAllRegionais(obj)
      .toPromise()
      .then(
        (response: any) => {
          this.regionais = response.body
            .filter((x) => x.nome)
            .sort((a, b) => (a.nome < b.nome ? -1 : 1));
          this.filteredRegionais.next(this.regionais.slice());
          this.regionalMultiFilter.valueChanges
            .pipe(takeUntil(this.onDestroy))
            .subscribe(() => {
              this.filtroGeral(
                this.regionais,
                this.regionalMultiFilter,
                this.filteredRegionais,
                'nome'
              );
            });
          if (
            (this.regionais != null && this.regionais.length == 1) ||
            this.perfilAcessoTipo === 3
          ) {
            this.isDisabledRegional = true;
            if (this.perfilAcessoTipo === 3) {
              this.panelForm
                .get('regionalIds')
                .setValue(this.regionais.map((x) => x.id));
            } else {
              this.panelForm
                .get('regionalIds')
                .setValue(this.regionais.map((x) => x.id));
            }
          }
          this.searchAgente();
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.isLoading = false;
          this.openSnackBar(
            'Erro ao carregar regionais, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message,
            'OK',
            10000,
            'danger-snackbar'
          );
        }
      );
  }

  private filtroGeral(
    filtro: any,
    multifilter: any,
    filtered: any,
    field: string
  ) {
    if (!filtro) {
      return;
    }
    let search = multifilter.value;
    if (!search) {
      filtered.next(filtro.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    filtered.next(
      filtro.filter(
        (response) => response[field].toLowerCase().indexOf(search) > -1
      )
    );
  }

  public onPageChange(evt: { pageIndex: number; pageSize: number }) {
    this.paging.index = evt.pageIndex;
    this.paging.size = evt.pageSize;
    this.search(false);
  }

  public initDateTimeFilter() {
    let finalFilter = new Date();
    finalFilter = new Date(
      finalFilter.getFullYear(),
      finalFilter.getMonth(),
      finalFilter.getDate(),
      finalFilter.getHours() - 3,
      finalFilter.getMinutes()
    );
    const initialFilter = new Date(finalFilter);
    initialFilter.setDate(initialFilter.getDate() - 7);
    this.panelForm.get('dataInicial').setValue(initialFilter);
    this.panelForm.get('dataFinal').setValue(finalFilter);
  }

  public clearFields() {
    this.agentes = [];
    this.regionais = [];
    this.agentesSelected = [];
    this.regionaisSelected = [];
    this.panelForm.reset();
    this.panelForm.updateValueAndValidity();

    this.paging.index = 0;
    this.panelCollection = new MatTableDataSource<any>();
    this.panelForm.get('tipoSituacaoVisualizacaoId').setValue('0');
    this.panelForm.get('necessarioME').setValue('-1');
    this.panelForm.get('tipoManifesto').setValue('Todos');
    this.initDateTimeFilter();
    this.initRegionais();
    this.initParameterFields();
  }

  public openSnackBar(
    message: string,
    action: string,
    duration: number,
    panelClass?: string
  ): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }

  public openSnackBarOnlyMessage(
    message: string,
    duration: number,
    panelClass?: string
  ): any {
    this.snackBar.open(message, null, { duration, panelClass });
  }

  public openModalMEDetalhe(item): void {
    const modalReference = this.dialog.open(
      ModalManifestoEmbarquePainelDetalheComponent,
      {
        width: '1240px',
        data: {
          item: {
            manifestoEmbarqueId: item.manifestoEmbarqueId,
            baixado: item.dtBaixa !== null,
          },
        },
      }
    );

    modalReference
      .afterClosed()
      .pipe(take(1))
      .subscribe(() => {
        // this.search();
      });
  }

  public baixarManifesto(item) {
    const dialogRef = this.dialog.open(ModalConfirmacaoComponent, {
      width: '540px',
      data: {
        textoCancelar: 'Não',
        textoOk: 'Sim',
        texto: 'Tem certeza que deseja efetuar a baixa deste manifesto?',
      },
    });

    dialogRef.afterClosed().subscribe(async (response) => {
      if (response === 1) {
        this.manifestoService
          .baixarManifesto({
            manifestoId: item.numeroManifesto
              .toString()
              .substring(0, item.numeroManifesto.toString().length - 1),
            manifestoDevolucao: item.tipo === 'Devolução',
            agenteId: item.agenteId,
          })
          .pipe(take(1))
          .subscribe(
            () => {
              dialogRef.close();
              this.search();
              this.openSnackBar('Manifesto baixado com sucesso!', 'OK', 5000);
            },
            (errorResponse) => {
              dialogRef.close();
              this.threatErrorAndSearch(errorResponse);
              // this.openSnackBar('Desculpe, aconteceu um erro!', 'OK', 5000);
            }
          );
      }
    });
  }

  private resetOrNotPagination(shouldResetPagination: boolean) {
    if (shouldResetPagination === true) {
      this.paging.index = 0;
      if (this.paginator) this.paginator.goTo = 1;
    }
  }

  private setLoading(isLoading) {
    this.isLoading = isLoading;
    if (isLoading === true) document.body.style.cursor = 'progress';
    else document.body.style.cursor = 'default';
  }

  private initParameters() {
    this.manifestoService
      .getManifestoParametro({
        chave: 'MODELO_FILTRO_PAINEL_MANIFESTOS',
      })
      .pipe(take(1))
      .subscribe(
        (response: HttpResponse<any[]>) => {
          this.modeloFiltroPainelManifesto = (<any>response.body).valor;
          this.initParameterFields();
          this.setLoading(false);
        },
        () => {
          this.setLoading(false);
          this.openSnackBar(
            'Erro ao carregar a parametrização!',
            'OK',
            5000,
            'danger-snackbar'
          );
        }
      );

    this.perfilAcessoTipo = StorageService.getPerfilUsuario().perfilacessotipo;
  }

  private initParameterFields() {
    if (this.modeloFiltroPainelManifesto === '2')
      this.panelForm.get('necessarioME').setValue('1');
    else if (this.modeloFiltroPainelManifesto === '3')
      this.panelForm.get('necessarioME').setValue('0');
  }

  private resetCardsFilterSelecteds(event: any) {
    this.cardsFilter.expiradosComRessalva = false;
    this.cardsFilter.expiradosSemRessalva = false;
    this.cardsFilter.naoExpiradosComRessalva = false;
    this.cardsFilter.naoExpiradosSemRessalva = false;
    this.cardsFilter.totalBaixados = false;
    this.cardsFilter.totalPendentes = false;
    this.cardsFilter[event.extra] = true;
  }

  private setDefaultSelected() {
    if (this.cardsFilter.totalPendentes === true)
      setTimeout(() => this.updateSelected({ extra: 'totalPendentes' }), 100);
    else if (this.cardsFilter.totalBaixados === true)
      setTimeout(() => this.updateSelected({ extra: 'totalBaixados' }), 100);
  }

  private threatErrorAndSearch(errorResponse) {
    if (errorResponse.status === 409) {
      this.openSnackBar(errorResponse.error, 'Ok', 5000, 'danger-snackbar');
    } else {
      this.openSnackBar(
        'Desculpe, aconteceu um erro!',
        'Ok',
        3000,
        'danger-snackbar'
      );
    }

    setTimeout(() => this.search(), 200);
  }

  public openModalSolicitacao(item, isDevolucao): void {
    const modalReference = this.dialog.open(
      ModalManifestoSolicitacaoProrrogacaoSlaComponent,
      {
        width: '700px',
        data: {
          item: {
            item: item,
            isDevolucao: isDevolucao,
          },
        },
      }
    );
    modalReference
      .afterClosed()
      .pipe(take(1))
      .subscribe((response) => {
        if (response) {
          this.search();
        }
      });
  }

  private changeCursorCards(element = null) {
    if (element) {
      if (this.isLoadingCards) {
        (<any>element.childNodes[0].childNodes[0]).style.cursor = 'progress';
      } else {
        (<any>element.childNodes[0].childNodes[0]).style.cursor = 'pointer';
      }
    } else {
      if (this.cards) {
        for (let index = 0; index < this.cards.length; index++) {
          const element = document.querySelectorAll('[ngx-charts-card]')[index];

          if (this.isLoadingCards) {
            (<any>element.childNodes[0].childNodes[0]).style.cursor =
              'progress';
          } else {
            (<any>element.childNodes[0].childNodes[0]).style.cursor = 'pointer';
          }
        }
      }
    }
  }
}
